// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","content":"Footer_content__EyWJb","link":"Footer_link__c7GbB"};